import React, { useEffect, useState } from 'react';
import AccordionList from '../common/AccordionList';
import { Button } from "bootstrap-4-react/lib/components";
import LoaderSpinner from "../common/Loader";
import { useDispatch, useSelector } from 'react-redux';
import { fetchDefaultCarrierServiceDefaults, updateDefaultCarrierServiceDefaults } from '../../store/actions';
import { toast } from "react-toastify";
import MarginCarrierFilter from '../MarginConfiguration/CarrierFilter';
import _ from 'lodash';

const DefaultCarrierServiceSettings = () => {
    const dispatch = useDispatch();
    const [carrierData, setCarrierData] = useState([]);
    const [allCarrierData, setAllCarrierData] = useState([]);
    const [editable, setEditable] = useState(true);
    const [isFormEdited, setIsFormEdited] = useState(false);
    const [showFilter, setShowFilter] = useState(false);
    const { defaultCarrierServices, defaultCarrierServicesStatus } = useSelector((state) => state.MarginReducer);
    const userDetails = useSelector((state) => state.auth.user);

    const [payloadData, setPayloadData] = useState({
        filterCarrierCompanyIds: [],
        filterCarrierServiceIds: [],
    });

    useEffect(() => {
        dispatch(fetchDefaultCarrierServiceDefaults());
    }, []);

    useEffect(() => {
        const entity = defaultCarrierServices?.Entity || (Array.isArray(defaultCarrierServices) ? defaultCarrierServices : null);
        if (entity) {
            const data = JSON.parse(JSON.stringify(entity));
            setAllCarrierData(data);
            setCarrierData(data);
        }
    }, [defaultCarrierServices]);

    const computeCarrierStatus = (services) => {
        return services.some(s => s.isActive);
    };

    const handleStatusChange = (status, index, serviceIndex) => {
        const data = JSON.parse(JSON.stringify(carrierData));
        data[index].services[serviceIndex].isActive = status;
        data[index].isActive = computeCarrierStatus(data[index].services);
        setIsFormEdited(true);
        setCarrierData(data);
    };

    const handleCarrierStatusChange = (checked, index) => {
        const data = JSON.parse(JSON.stringify(carrierData));
        data[index].isActive = checked;
        data[index].services = data[index].services.map(s => ({ ...s, isActive: checked }));
        setIsFormEdited(true);
        setCarrierData(data);
    };

    const handleSave = async () => {
        const payload = {
            Updates: carrierData.map(carrier => ({
                CarrierCompanyId: carrier.carrierCompanyId,
                IsActive: carrier.isActive,
                Services: carrier.services.map(s => ({
                    CarrierServiceId: s.carrierServiceId || s.id,
                    IsActive: s.isActive
                }))
            }))
        };
        try {
            const response = await Promise.resolve(dispatch(updateDefaultCarrierServiceDefaults(payload)));
            if (response?.data?.Status === 200) {
                toast.success('Default carrier settings saved successfully');
                setIsFormEdited(false);
                setEditable(false);
                dispatch(fetchDefaultCarrierServiceDefaults());
            } else {
                toast.error(response?.data?.Message?.AppStatusDescription || 'Failed to save default settings');
            }
        } catch {
            toast.error('An error occurred while saving default settings');
        }
    };

    const handleFilter = () => {
        let filtered = JSON.parse(JSON.stringify(allCarrierData));
        const carrierIds = _.map(payloadData.filterCarrierCompanyIds, "id");
        const serviceIds = _.map(payloadData.filterCarrierServiceIds, "id");
        if (carrierIds.length > 0) {
            filtered = filtered.filter(c => carrierIds.includes(c.carrierCompanyId));
        }
        if (serviceIds.length > 0) {
            filtered = filtered.map(c => ({
                ...c,
                services: c.services.filter(s => serviceIds.includes(s.carrierServiceId || s.id))
            })).filter(c => c.services.length > 0);
        }
        setCarrierData(filtered);
    };

    const handleFilterValue = (value, type) => {
        setPayloadData({ ...payloadData, [type]: value });
    };

    const handleResetFilter = () => {
        setPayloadData({ filterCarrierCompanyIds: [], filterCarrierServiceIds: [] });
        setCarrierData(JSON.parse(JSON.stringify(allCarrierData)));
    };

    return (
        <div>
            <div className="main__tile_heading cus-btn-include-sec">
                <div>Default Carrier Service Settings</div>
                <div className="top_right_button_container">
                    <Button
                        className="cus-seconday-bg-btn top-btn"
                        onClick={() => setShowFilter(!showFilter)}
                    >
                        <i className="fa fa-filter" aria-hidden="true"></i> Filter
                    </Button>
                    <button
                        className="btn cus-seconday-bg-btn top-btn editBtn"
                        onClick={() => setEditable(true)}
                        disabled={editable}
                    >
                        Edit
                    </button>
                    <button
                        className="btn cus-seconday-bg-btn top-btn"
                        onClick={handleSave}
                        disabled={!isFormEdited}
                    >
                        Save
                    </button>
                </div>
            </div>

            <div className="mb-3 pl-3">
                <div className="alert alert-info" role="alert" style={{ fontSize: '13px' }}>
                    <i className="fa fa-info-circle me-2 pr-1" aria-hidden="true"></i>These settings apply only to newly created seller accounts. Existing seller configurations are not affected.
                </div>
            </div>

            {defaultCarrierServicesStatus === 'pending' && <LoaderSpinner />}

            <MarginCarrierFilter
                showFilter={showFilter}
                userDetails={userDetails}
                handleResetFilter={handleResetFilter}
                handleFilter={handleFilter}
                payloadData={payloadData}
                setPayloadData={setPayloadData}
                handleFilterValue={handleFilterValue}
            />

            <div className="cus-page-content-sec">
                <div className="top_right_button_container cus-content-only-sec">
                    <div className="incoming_wrapper main_content_table incomingTbl">
                        <div className='pl-3 pr-3'>
                            {defaultCarrierServicesStatus === 'success' && carrierData.length > 0 ? (
                                <AccordionList
                                    userDetails={userDetails}
                                    handleStatusChange={handleStatusChange}
                                    handleCarrierStatusChange={handleCarrierStatusChange}
                                    data={carrierData}
                                    edit={editable}
                                    isSeller={true}
                                    showCarrierToggle={true}
                                />
                            ) : null}
                            {carrierData.length === 0 && defaultCarrierServicesStatus === 'success' && (
                                <div className='alignCenter'>No carriers configured</div>
                            )}
                            {defaultCarrierServicesStatus === 'failure' && (
                                <div className='alignCenter text-danger'>Failed to load default carrier settings. Please try again later.</div>
                            )}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default DefaultCarrierServiceSettings;
